import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import PointCard from './DashBoardCards/PointCard';
import MessagePointCard from './DashBoardCards/MessagePointCard';
import RatingCard from './DashBoardCards/RatingCard';
import GiftsCard from './DashBoardCards/GiftsCard';
import LatteryCard from './DashBoardCards/LatteryCard';
import SerialRegisterCard from './DashBoardCards/SerialRegisterCard';
import BarChartCard from './DashBoardCards/BarChartCard';
import axios from 'axios';
import { getAuthenticationToken } from '../utils/TokenHandler';
import MaterialNotifyComponent from './MaterialNotifyComponent';
import { setUserProfile } from '../utils/userProfile';
import { withRouter } from 'react-router-dom';
import Backdrop from '@mui/material/Backdrop';
import { CircularProgress } from '@mui/material';
import AddGiftCardCard from './DashBoardCards/GiftCardCard';
import WalletCard from './DashBoardCards/WalletCard';

function MainContent(props) {
    const { history } = props
    //State-----------------------------------------------
    const [dashboardData, setDashboardData] = useState(null);
    const [messageNotify, setMessageNotify] = useState({ severity: "warning", message: "", open: false });
    const [open, setOpen] = useState(true);
    //----------------------------------------------------

    const getPoints = (isForMerchant) => {
        let sumPoint = 0;
        try {
            dashboardData.pointViewModel.filter((x) => x.isForMerchant === isForMerchant).forEach(item => sumPoint += item.totalPoint);
        } catch { }
        return sumPoint;
    }; 
    
    const getWalletCreaditAmount = () => {
        try {
            return dashboardData.creditWalletAmount;
        } catch { }
        return 0;
    };


    useEffect(() => {
        setOpen(true);
        axios.get('api/v2/Dashboard/GetDashboardNew', {
            params:
            {
                userId: getAuthenticationToken().userID
            }
        }).then((response) => {
            setDashboardData(response.data);
            setUserProfile({
                customerUserName: response.data.customerUserName,
                customerName: response.data.customerName,
                profileCDNImage: response.data.profileCDNImage,
                customerType: response.data.customerType
            });
        }).catch((e) => {
            setMessageNotify({
                severity: "error",
                message: "خطا در فراخوانی اطلاعات از سرور",
                open: true
            });
        }).finally(() => {
            setOpen(false);
        })
    }, []);
    if (dashboardData !== null) {
        return (
            <>
                <SubContainer>
                    <PointCard SumPoint={getPoints(false)} clickCardHandler={() => history.push('/scoredetail')} />
                    <RatingCard rankColor={dashboardData.customerRank.colorCode} customerRate={dashboardData.customerRank.name} customerGroup={dashboardData.customerGroupName} />
                    <WalletCard CreditAmount={getWalletCreaditAmount()} />
                    <SerialRegisterCard clickCardHandler={() => history.push('/customeraddtoolsserial')}  />
                    <GiftsCard clickCardHandler={() => history.push('/customerrepresenteradd')}  />
                    <AddGiftCardCard clickCardHandler={() => history.push('/addgiftcard')}/>
                </SubContainer>
                <MaterialNotifyComponent onclose={() => { setMessageNotify({ ...messageNotify, open: false }) }} open={messageNotify.open} severity={messageNotify.severity} message={messageNotify.message} />
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={open}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            </>
        )
    }
    else {
        return (
            <>
                <SubContainer>
                    <PointCard SumPoint="0" />
                    <RatingCard customerRate="" customerGroup="" />
                    <WalletCard CreditAmount="0" />
                    <SerialRegisterCard />
                    <GiftsCard />
                    <AddGiftCardCard />
                </SubContainer>
                <MaterialNotifyComponent onclose={() => { setMessageNotify({ ...messageNotify, open: false }) }} open={messageNotify.open} severity={messageNotify.severity} message={messageNotify.message} />
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={open}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            </>
        )
    }
}

const SubContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: space-between;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    @media screen and (min-width: 320px) and (max-width: 1080px){
        flex-direction: column;
        height: 100%;
    }
`;

export default withRouter(MainContent);